// src/pages/Reports/IssuanceReporting/AgentPrintHouseSummary/index.tsx
// README.md mục 7 — trang "Theo đại lý & Nhà in": RPT-011 (vé đã bán), RPT-012 (tổng hợp theo đại
// lý), RPT-013 (theo nhà in). Chỉ đọc, không Redux slice riêng.

import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Container, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import BreadCrumb from 'Components/Common/BreadCrumb';
import { useBrandingTitle } from 'hooks';
import TicketSoldTab from './TicketSoldTab';
import AgentSummaryTab from './AgentSummaryTab';
import PrintHouseSummaryTab from './PrintHouseSummaryTab';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

type TabKey = 'sold' | 'agentSummary' | 'printHouseSummary';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'sold', label: st('ve_da_ban_label') },
  { key: 'agentSummary', label: st('tong_hop_theo_dai_ly_label') },
  { key: 'printHouseSummary', label: st('theo_nha_in_label') },
];

const AgentPrintHouseSummaryPage: React.FC = () => {
  useBrandingTitle(st('theo_dai_ly_nha_in_text'));
  const [activeTab, setActiveTab] = useState<TabKey>('sold');

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={st('theo_dai_ly_nha_in_text')} pageTitle={st('bao_cao_phat_hanh_text')} />

        <Card>
          <CardHeader className="card-header border-0">
            <Nav tabs className="nav-tabs-custom card-header-tabs flex-wrap">
              {TABS.map((tab) => (
                <NavItem key={tab.key}>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === tab.key })}
                    onClick={(e) => { e.preventDefault(); setActiveTab(tab.key); }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </CardHeader>
          <CardBody>
            {activeTab === 'sold' && <TicketSoldTab />}
            {activeTab === 'agentSummary' && <AgentSummaryTab />}
            {activeTab === 'printHouseSummary' && <PrintHouseSummaryTab />}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AgentPrintHouseSummaryPage;
